import React from 'react';
import styles from './OrganizationsTable.module.css';

import {Loader, Table} from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import ArrowsSvg from '@icons/Arrows.svg';
import SortUpSvg from '@icons/SortUp.svg';
import SortDownSvg from '@icons/SortDown.svg';

const OrganizationTable = ({ organizations, sortName, sortValue, sort, isLoading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (id) => {
    navigate(`/organizations/${id}`)
  }

  const getIcon = (name) => {
    if (sortName !== name) {
      return ArrowsSvg;
    }

    if (sortValue === -1) {
      return SortUpSvg
    } else {
      return SortDownSvg;
    }
  }

  const showDate = (value) => {
    const myDate = new Date(value);
    let m = myDate.getMonth() + 1;
    let d = myDate.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;

    return `${d}.${m}.${myDate.getFullYear()}`;
  }

  const rows = organizations.map((element) => (
    <Table.Tr key={element.id} className={styles.bodyTr} onClick={() => handleClick(element.id)}>
      <Table.Td className={styles.nameTh}>{element.name}</Table.Td>
      <Table.Td
        className={styles.statusTh}
      >
        {showDate(element.created)}
      </Table.Td>
    </Table.Tr>
  ));

  return isLoading ? (
      <div className={styles.loader}>
        <Loader/>
      </div>
  ) : (
      <div className={styles.wrapper}>
    <Table stickyHeader stickyHeaderOffset={0}>
      <Table.Thead className={styles.thead}>
        <Table.Tr className={styles.headTr}>
          <Table.Th className={styles.headThName}>
            <div className={styles.contentName}>
              {t('organizations.table.head1')}

              <div className={styles.sort}>
                <img src={getIcon('name')} onClick={() => sort('name')} />
              </div>
            </div>
          </Table.Th>
          <Table.Th className={styles.headTh}>
            <div className={styles.content}>
              {t('organizations.table.head2')}

              <div className={styles.sort}>
                <img src={getIcon('date')} onClick={() => sort('date')} />
              </div>
            </div>
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
      </div>
  )
}

export default OrganizationTable;
